import { render, staticRenderFns } from "./MethodOfDelivery.vue?vue&type=template&id=46079b58"
import script from "./MethodOfDelivery.vue?vue&type=script&lang=ts"
export * from "./MethodOfDelivery.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports